import intlTelInput, { NUMBER_FORMAT, VALIDATION_ERROR } from "intl-tel-input";
import utils from "intl-tel-input/dist/js/utils.js";
import "intl-tel-input/dist/css/intlTelInput.css";
import "./PhoneNumberTemplate.cshtml.scss";
import CommonFunctions from "../../../wwwroot_src/src/GlobalScripts/CommonFunctions";

const PHONE_NUMBER_WHITESPACE_REGEX = /\s|\u00A0/g;

export class PhoneNumberTemplateBase {
    static init(controlId: string) {
        const inputEl = document.getElementById(controlId) as HTMLInputElement | null;
        if (!inputEl) {
            return;
        }

        const hiddenId = controlId.replace("_ctrl", "");
        const hiddenEl = document.getElementById(hiddenId) as HTMLInputElement | null;
        //remove whitespaces
        inputEl.value = removePhoneNumberWhitespaces(inputEl.value);

        const iti = intlTelInput(inputEl, {
            initialCountry: CommonFunctions.getDefaultLanguage() as any,
            countryOrder: ["ch", "de", "at", "li"],
            nationalMode: true,
            separateDialCode: false,
            strictMode: false,
            strictRejectAnimation: false,
            useFullscreenPopup: false,
            dropdownContainer: document.body,
            loadUtils: () => Promise.resolve({ default: utils }),
            countryNameOverrides: {
                ch: TextResources.Views_Schweiz,
                de: TextResources.Views_Deutschland,
                at: TextResources.Views_Oesterreich,
            },
            i18n: {
                searchPlaceholder: TextResources.Views_Filter,
                clearSearchAriaLabel: TextResources.Views_ClearField,
                searchEmptyState: TextResources.Error_KeineEintraege,
            }
        });

        inputEl.setAttribute("name", controlId);
        takeCountryButtonOutOfTabOrder(inputEl);

        const setVal = () => {
            if (hiddenEl) hiddenEl.value = iti.getNumber(NUMBER_FORMAT.INTERNATIONAL);
        };

        const formatDisplayValue = () => {
            const countryData = iti.getSelectedCountryData();
            const nationalNumber = utils.formatNumber(
                iti.getNumber(NUMBER_FORMAT.INTERNATIONAL),
                countryData?.iso2,
                NUMBER_FORMAT.NATIONAL);
            if (nationalNumber) {
                inputEl.value = nationalNumber;
            }
        };

        const syncPhoneNumber = () => {
            formatDisplayValue();
            setVal();
        };

        iti.promise.then(() => {
            syncPhoneNumber();
            // Kendo TextBox writes its initial value after the inline template script.
            $(syncPhoneNumber);
        });

        inputEl.addEventListener("blur", syncPhoneNumber);
        inputEl.addEventListener("change", setVal);


        (inputEl as any).iti = iti;
        (inputEl as any).isValidOrPossiblePhoneNumber = () => iti.isValidNumber() || iti.getValidationError() === VALIDATION_ERROR.IS_POSSIBLE;
    }
}

function removePhoneNumberWhitespaces(value: string): string {
    return value.replace(PHONE_NUMBER_WHITESPACE_REGEX, "");
}

/**
 * intl-tel-input renders the country button *before* the input, so tabbing into the field lands on the
 * flag and a second Tab is needed to reach the number - for a control the user fills in by typing.
 * Kendo has the same situation with its picker buttons and solves it the same way: the button leaves the
 * tab order and the popup opens with Alt+ArrowDown from the input. The country stays reachable by mouse,
 * by that shortcut, and by typing an international prefix (intl-tel-input picks the country up from it).
 */
function takeCountryButtonOutOfTabOrder(inputEl: HTMLInputElement) {
    const countryButton = inputEl.closest(".iti")?.querySelector<HTMLButtonElement>(".iti__selected-country");
    if (!countryButton) {
        return;
    }

    countryButton.tabIndex = -1;
    inputEl.setAttribute("aria-keyshortcuts", "Alt+ArrowDown");
    inputEl.addEventListener("keydown", (event: KeyboardEvent) => {
        if (event.altKey && event.key === "ArrowDown") {
            event.preventDefault();
            countryButton.click();
        }
    });
}
